"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarExplorer = void 0;
const TileType_1 = require("../TileType");
class PolarExplorer {
    constructor() {
        this.name = 'Polar Explorer';
        this.description = 'Have at least 3 tiles on the bottom two rows';
    }
    getScore(player) {
        return player.game.board.spaces
            .filter((space) => space.player !== undefined &&
            space.player === player &&
            space.tile !== undefined &&
            TileType_1.isAresTile(space.tile.tileType) === false &&
            space.y >= 7 && space.y <= 8).length;
    }
    canClaim(player) {
        return this.getScore(player) >= 3;
    }
}
exports.PolarExplorer = PolarExplorer;
//# sourceMappingURL=PolarExplorer.js.map